(function (angular) {
	'use strict';

	angular
		.module('settingsModule')
		.controller('EditJointAccount', [
			'$filter',
			'globalConfig',
			'mixpanelFactory',
			'US_STATES',
			EditJointAccountFunction
		]);

	function EditJointAccountFunction(
		$filter,
		globalConfig,
		mixpanelFactory,
		US_STATES
	) {
		var editJointAccount = this;
		var validStates;

		editJointAccount.updateShowPartyPercentageOwnership = function() {
			editJointAccount.showPartyPercentageOwnership = editJointAccount.jointAccountType.value === 'TENANTS_IN_COMMON';
		};

		editJointAccount.updatePercentOwnership = function() {
			if(angular.isDefined(editJointAccount.firstPartyPercentageOwnership)) {
				editJointAccount.secondPartyPercentageOwnership = 100 - Number(editJointAccount.firstPartyPercentageOwnership);
			}
		};

		editJointAccount.updateCommunityPropertyStateValidation = function() {
			var isStateValid = isCommunityPropertyStateValid(editJointAccount.serializedForm.state);
			editJointAccount.jointAccountForm.state.$setValidity('state', isStateValid);
		};

		editJointAccount.updateCommunityPropertySecondPartyStateValidation = function() {
			if(editJointAccount.secondPartyAddressIsSame) {
				editJointAccount.updateCommunityPropertyStateValidation();
				editJointAccount.jointAccountForm.secondPartyState.$setValidity('secondPartyState', true);
			} else {
				var isSecondPartyStateValid = isCommunityPropertyStateValid(editJointAccount.serializedForm.secondPartyState);
				editJointAccount.jointAccountForm.secondPartyState.$setValidity('secondPartyState', isSecondPartyStateValid);
			}
		};
		
		function isCommunityPropertyStateValid(state) {
			if(editJointAccount.jointAccountType.value === 'COMMUNITY_PROPERTY') {
				return $filter('filter')(validStates, state.abbreviation).length > 0;
			}
			return true;
		}

		(function init() {
			editJointAccount.states = US_STATES;

			angular.extend(editJointAccount, globalConfig);

			editJointAccount.jointAccountType = $filter('filter')(editJointAccount.jointAccountTypes, {'value': editJointAccount.serializedForm.jointAccountType}, true)[0] || editJointAccount.jointAccountTypes[0];
			editJointAccount.serializedForm.state = $filter('findSelectedOption')(editJointAccount.serializedForm.state, 'abbreviation', editJointAccount.states);
			editJointAccount.serializedForm.secondPartyState = $filter('findSelectedOption')(editJointAccount.serializedForm.secondPartyState, 'abbreviation', editJointAccount.states);

			editJointAccount.showSecondPartyName = !editJointAccount.serializedForm.secondPartyFirstName && !editJointAccount.serializedForm.secondPartyLastName;
			editJointAccount.showSsn = !editJointAccount.serializedForm.ssn;
			editJointAccount.showSecondPartySsn = !editJointAccount.serializedForm.secondPartySsn;

			editJointAccount.secondPartyAddressIsSame = editJointAccount.serializedForm.secondPartyAddressIsSame || false;

			editJointAccount.firstPartyPercentageOwnership = editJointAccount.serializedForm.firstPartyPercentageOwnership || 50;
			editJointAccount.secondPartyPercentageOwnership = editJointAccount.serializedForm.secondPartyPercentageOwnership || 50;
			editJointAccount.updateShowPartyPercentageOwnership();
			validStates = ["AA", "AE", "AP", "AZ", "CA", "ID", "LA", "NV", "NM", "TX", "WI", "WA"];

			mixpanelFactory.track('Profile Form viewed', { 'Entity Type' : 'JOINT_ACCOUNT' });
		})();
	}
})(window.angular);